import { colors } from "@obs/tokens/index.stylex.ts";
import * as stylex from "@stylexjs/stylex";

import { TagPrimitive, type TagProps } from "../primitives/TagPrimitive";

const styles = stylex.create({
	root: {
		backgroundColor: colors.accentBgWeak,
		color: colors.accentTxtDefault,
	},
});

export const AccentWeak = ({ label, sx, ...htmlProps }: TagProps) => {
	return <TagPrimitive label={label} sx={[styles.root, sx]} {...htmlProps} />;
};
